// ── 弹框属性切换：文档级事件代理 ──────────────────────────────────────────────
// 使用 window._mskuModalDelegateSet 保证本函数只注册一次，无论 msku-picker.js
// 被加载/执行多少次（PDP 自身 + modal cloneNode 重插入均只执行一次）
if (!window._mskuModalDelegateSet) {
  window._mskuModalDelegateSet = true;
  // 页面级共享缓存：key=product.url，value=HTML string（已完成）或 Promise（进行中）
  window._mskuPageCache = window._mskuPageCache || {};
  window._mskuModalLoadSeq = window._mskuModalLoadSeq || 0; // 序列号，用于取消过时的异步回调

  function _mskuResetModalLayout(container) {
    var modal = container.closest('tool-tip');
    if (modal) {
      modal.removeAttribute('data-msku-size-locked');
      modal.style.removeProperty('--msku-panel-height');
      var loader = modal.querySelector('[data-msku-switch-loader]');
      if (loader) loader.remove();
    }
    container.style.removeProperty('--msku-product-min-height');
    container.style.minHeight = '';
  }
  window._resetMskuQuickViewLayout = _mskuResetModalLayout;

  document.addEventListener('tooltip:close', function(e) {
    if (e.detail.context !== 'QuickShop') return;
    window._mskuModalLoadSeq += 1;
    var container = e.target.querySelector('[data-tool-tip-content]');
    if (!container) return;
    _mskuResetModalLayout(container);
    container.classList.remove('msku-switch-is-loading');
    container.style.minHeight = '';
    container.removeAttribute('aria-busy');
    var loader = container.querySelector('[data-msku-switch-loader]');
    if (loader) loader.remove();
  });

  window._mskuPrefetchedUrls = window._mskuPrefetchedUrls || {};

  function _mskuQuickViewUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('view', 'form');
      return parsed.pathname + parsed.search;
    } catch (_e) {
      return url + (String(url).indexOf('?') === -1 ? '?' : '&') + 'view=form';
    }
  }

  function _mskuCanPrefetch() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    return connection.effectiveType !== 'slow-2g' && connection.effectiveType !== '2g';
  }

  function _mskuPrefetchProduct(product) {
    if (!product || !product.url || !_mskuCanPrefetch()) return;
    var absoluteUrl;
    try {
      absoluteUrl = new URL(product.isModal ? _mskuQuickViewUrl(product.url) : product.url, window.location.href).href;
    } catch (_e) { return; }
    if (absoluteUrl === window.location.href || window._mskuPrefetchedUrls[absoluteUrl]) return;
    window._mskuPrefetchedUrls[absoluteUrl] = true;

    var pageLink = document.createElement('link');
    pageLink.rel = 'prefetch';
    pageLink.href = absoluteUrl;
    pageLink.fetchPriority = 'low';
    document.head.appendChild(pageLink);

    var imageUrl = product.image || (product.images && product.images[0]);
    if (imageUrl) {
      var imageLink = document.createElement('link');
      imageLink.rel = 'prefetch';
      imageLink.as = 'image';
      imageLink.href = imageUrl;
      imageLink.fetchPriority = 'low';
      document.head.appendChild(imageLink);
    }
  }

  window._mskuPrefetchProduct = _mskuPrefetchProduct;

  var _mskuIntentTimer = null;

  function _mskuProductFromIntent(e) {
    var el = e.target;
    if (!el || !el.closest) return null;
    var input = el.matches('input[data-product-url]') ? el : null;
    if (!input) {
      var label = el.closest('label');
      var candidate = label && label.previousElementSibling;
      if (candidate && candidate.matches('input[data-product-url]')) input = candidate;
    }
    if (!input) return null;
    return {
      url: input.dataset.productUrl,
      image: input.dataset.productImage,
      isModal: Boolean(input.closest('[data-modal]'))
    };
  }

  function _mskuPrefetchFromIntent(e) {
    var product = _mskuProductFromIntent(e);
    if (!product) return;
    clearTimeout(_mskuIntentTimer);
    if (e.type === 'pointerover') {
      _mskuIntentTimer = setTimeout(function() { _mskuPrefetchProduct(product); }, 120);
    } else {
      _mskuPrefetchProduct(product);
    }
  }

  document.addEventListener('pointerover', _mskuPrefetchFromIntent, true);
  document.addEventListener('pointerout', function() { clearTimeout(_mskuIntentTimer); }, true);
  document.addEventListener('focusin', _mskuPrefetchFromIntent, true);
  document.addEventListener('touchstart', _mskuPrefetchFromIntent, { capture: true, passive: true });

  // 给 modal 内的 radio 追加 --modal 后缀，使其与 PDP radio 组隔离，防止浏览器将
  // 两者视为同一 radio group（相同 name 会导致 PDP 的 change 事件被触发 → 意外导航）
  function _mskuIsolateModalRadios(container) {
    var inputs = container.querySelectorAll('input[type="radio"][data-attr-key]');
    for (var mi = 0; mi < inputs.length; mi++) {
      if (!inputs[mi].name.endsWith('--modal')) {
        inputs[mi].name += '--modal';
      }
    }
  }

  function _mskuPrepareModalProduct(productElement) {
    var breadcrumbs = productElement.querySelector('.breadcrumb');
    if (breadcrumbs) breadcrumbs.remove();
    var variantPicker = productElement.querySelector('block-variant-picker');
    if (variantPicker) variantPicker.removeAttribute('data-update-url');
    productElement.dataset.modal = 'true';
    productElement.dataset.quickShopLayout = 'collection';
    productElement.classList.add('quick-shop-layout--collection');

    var productMeta = productElement.querySelector('.product-single__meta');
    if (productMeta) {
      var title = productMeta.querySelector('.product-single__title');
      var titleBlock = title && title.closest('.product-block');
      var priceBlock = productMeta.querySelector('.block-price.product-block');
      var couponBox = productMeta.querySelector('.elsklip-coupon-box[data-klip-product]:not([data-short])');
      var couponBlock = couponBox && (couponBox.closest('.shopify-app-block') || couponBox.closest('.shopify-block') || couponBox.closest('.product-block') || couponBox);
      var orderedBlocks = [titleBlock, priceBlock, couponBlock].filter(Boolean);
      var insertionPoint = productMeta.firstElementChild;
      orderedBlocks.forEach(function(block) {
        if (block === insertionPoint) {
          insertionPoint = insertionPoint.nextElementSibling;
          return;
        }
        productMeta.insertBefore(block, insertionPoint);
      });
    }
    productElement.dataset.quickShopCanonicalContent = '';
  }

  // 从 scope 内读取 JSON 数据，直接渲染 msku picker，不依赖脚本重执行
  function _mskuRenderInModal(scope) {
    var dataEl = scope.querySelector('[data-msku-group-data]');
    var container = scope.querySelector('[data-msku-picker-container]');
    if (!dataEl || !container) return;

    var gd;
    try { gd = JSON.parse(dataEl.textContent); } catch (_e) { return; }
    var gp = gd.groupProducts;
    if (!gp || gp.length < 2) return;

    var cid = gd.currentProductId;
    var sd = gd.swatchData || {};
    var nsd = {};
    Object.keys(sd).forEach(function(k) { nsd[k.trim().toLowerCase()] = sd[k]; });

    var om = {};
    for (var _ri = 0; _ri < gp.length; _ri++) {
      var _ra = gp[_ri].attributes || {};
      Object.keys(_ra).forEach(function(k) {
        if (!om[k]) om[k] = [];
        if (om[k].indexOf(_ra[k]) === -1) om[k].push(_ra[k]);
      });
    }
    var ks = Object.keys(om);
    var nq = ks.filter(function(k) { var l = k.toLowerCase(); return l.indexOf('quantity') === -1 && l.indexOf('qty') === -1; });
    var qk = ks.filter(function(k) { var l = k.toLowerCase(); return l.indexOf('quantity') !== -1 || l.indexOf('qty') !== -1; });
    ks = nq.concat(qk);

    var cp = null;
    for (var _ri2 = 0; _ri2 < gp.length; _ri2++) {
      if (String(gp[_ri2].id) === String(cid)) { cp = gp[_ri2]; break; }
    }
    var sa = cp ? Object.assign({}, cp.attributes) : {};

    function _esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
    function _fp(attrs) {
      var ak = Object.keys(attrs);
      for (var _fi = 0; _fi < gp.length; _fi++) {
        var _fp2 = gp[_fi]; if (!_fp2.attributes) continue;
        var ok = true;
        for (var _fk = 0; _fk < ak.length; _fk++) { if (_fp2.attributes[ak[_fk]] !== attrs[ak[_fk]]) { ok = false; break; } }
        if (ok) return _fp2;
      }
      return null;
    }

    var html = '';
    for (var _ri3 = 0; _ri3 < ks.length; _ri3++) {
      var attrKey = ks[_ri3];
      var vals = om[attrKey];
      var selVal = sa[attrKey] || '';
      var isColor = attrKey.toLowerCase() === 'color' || attrKey.toLowerCase() === 'colour';

      html += '<fieldset class="variant-button-wrap' + (isColor ? ' is_color_active' : '') + '">';
      html += '<legend class="label variant__label"><span class="variant__label-left">';
      html += _esc(attrKey) + ': ';
      html += '<span class="variant__label-info"><span data-variant-color-label>' + _esc(selVal) + '</span></span>';
      html += '</span>';
      if (_ri3 === ks.length - 1 && cp && cp.restockTime) {
        html += '<span class="in-stock-in-4-weeks" role="status" aria-live="polite">';
        html += '<span class="stock-main-label">' + _esc(cp.restockTime) + '</span></span>';
      }
      html += '</legend>';

      for (var _rj = 0; _rj < vals.length; _rj++) {
        var val = vals[_rj];
        var isSel = val === selVal;
        var inputId = String(cid) + '-msku-' + _ri3 + '-' + _rj;
        var ta = Object.assign({}, sa); ta[attrKey] = val;
        var tgt = _fp(ta);
        var isUnavail = !tgt || !tgt.available;

        html += '<input class="visually-hidden" type="radio"';
        html += ' id="' + inputId + '" name="msku-' + _esc(attrKey) + '"';
        html += ' value="' + _esc(val) + '"';
        html += ' data-attr-key="' + _esc(attrKey) + '" data-attr-val="' + _esc(val) + '"';
        if (tgt) {
          html += ' data-product-id="' + _esc(tgt.id) + '"';
          html += ' data-variant-id="' + _esc(tgt.variantId) + '"';
          html += ' data-product-url="' + _esc(tgt.url) + '"';
          if (tgt.images && tgt.images[0]) html += ' data-product-image="' + _esc(tgt.images[0]) + '"';
        }
        if (isSel) html += ' checked';
        if (isUnavail) html += ' data-disabled';
        html += '>';

        html += '<label class="variant__button-label" for="' + inputId + '"';
        if (isUnavail) html += ' data-disabled=""';
        if (isColor) {
          var swk = val.trim().toLowerCase();
          var swe = nsd[swk] || null;
          html += ' data-color-swatch="' + _esc(attrKey) + '"';
          html += ' data-msku-swatch-key="' + _esc(swk) + '"';
          html += ' data-msku-swatch-found="' + (swe ? 'true' : 'false') + '"';
          if (swe) {
            var si = swe.image || swe.simage || '';
            var sc = swe.color || swe.scolor || '';
            if (si) html += ' style="--swatch-bg-image:url(' + si + ');--swatch-bg-color:transparent;background-image:url(' + si + ');background-size:cover;background-color:transparent;"';
            else if (sc) html += ' style="--swatch-bg-color:' + sc + ';--swatch-bg-image:none;background-color:' + sc + ';"';
          }
        }
        html += '>' + _esc(val);
        if (isUnavail) html += '<span class="visually-hidden">Unavailable</span>';
        html += '</label>';
      }
      html += '</fieldset>';
    }

    container.innerHTML = html;
    _mskuIsolateModalRadios(container);
  }

  // fetch + cloneNode 注入的 module script 不会自动执行。MSKU 切换后需要重新执行
  // 当前商品弹框内的初始化脚本，否则新的 Buy Now 按钮不会绑定点击事件。
  function _mskuExecuteModalModules(scope) {
    var scripts = scope.querySelectorAll('script[type="module"]');
    for (var i = 0; i < scripts.length; i++) {
      var source = scripts[i];
      if (!source.parentNode) continue;
      var script = document.createElement('script');
      script.type = 'module';
      script.textContent = source.textContent;
      source.parentNode.replaceChild(script, source);
    }
  }

  // container 参数：从事件里取到精确的 [data-tool-tip-content]，避免多弹框时选错容器
  function _mskuLoadProductInModal(product, container) {
    var qs = container || document.querySelector('[data-tool-tip-content]');
    if (!qs) return;

    var modal = qs.closest('tool-tip');
    if (modal && (modal.dataset.toolTipOpen !== 'true' || modal.dataset.toolTip !== 'QuickShop')) return;
    var loadingHost = modal && modal.querySelector('[data-tool-tip-inner]') || qs;
    var mySeq = ++window._mskuModalLoadSeq; // 防止快速连续切换时过时回调覆盖最新结果
    var loadingTimer = null;

    // Keep the current panel and aligned product row for this opening. Releasing a
    // temporary min-height after two frames made the centered modal jump again.
    if (modal && !modal.hasAttribute('data-msku-size-locked')) {
      var panel = modal.querySelector('[data-tool-tip-inner]');
      var productGrid = qs.querySelector('.product-grid__container');
      if (panel) modal.style.setProperty('--msku-panel-height', panel.getBoundingClientRect().height + 'px');
      if (productGrid) qs.style.setProperty('--msku-product-min-height', productGrid.getBoundingClientRect().height + 'px');
      modal.setAttribute('data-msku-size-locked', '');
    }

    function _isCurrent() {
      return window._mskuModalLoadSeq === mySeq && document.contains(qs) && (!modal || (modal.dataset.toolTipOpen === 'true' && modal.dataset.toolTip === 'QuickShop'));
    }

    // 缓存未命中时延迟显示 Loading，避免快速响应也产生闪烁。
    function _showLoading() {
      if (!_isCurrent()) return;
      qs.classList.add('msku-switch-is-loading');
      qs.setAttribute('aria-busy', 'true');

      if (loadingHost.querySelector('[data-msku-switch-loader]')) return;
      var loader = document.createElement('div');
      loader.className = 'msku-switch-loader';
      loader.setAttribute('data-msku-switch-loader', '');
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-live', 'polite');
      loader.setAttribute('aria-label', 'Loading product');
      loader.innerHTML =
        '<span class="msku-switch-loader__spinner" aria-hidden="true"></span>';
      // Attach to the panel so the mask and spinner stay centered while content scrolls.
      loadingHost.appendChild(loader);
    }

    function _startLoading() {
      loadingTimer = setTimeout(_showLoading, 180);
    }

    function _finishLoading() {
      clearTimeout(loadingTimer);
      if (window._mskuModalLoadSeq !== mySeq) return;
      var loader = loadingHost.querySelector('[data-msku-switch-loader]');
      if (loader) loader.remove();
      qs.classList.remove('msku-switch-is-loading');
      qs.removeAttribute('aria-busy');
    }

    function _apply(text) {
      // 已有更新请求发出，或容器已从 DOM 中移除（弹框已关闭），跳过本次渲染
      if (!_isCurrent()) return;
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var newDiv = doc.querySelector('.page-content[data-product-id="' + product.id + '"]');
      if (!newDiv) {
        _finishLoading();
        console.error('[msku] product content was not found in the Quick View response');
        return;
      }
      _mskuPrepareModalProduct(newDiv);
      // 在插入 live DOM 之前隔离 radio name，消除与 PDP radio 同名的竞争窗口
      var _cloned = newDiv.cloneNode(true);
      if (window._prepareQuickShopContent) window._prepareQuickShopContent(_cloned);
      else _mskuRenderInModal(_cloned);
      _mskuIsolateModalRadios(_cloned);
      // 首次切换时从现有内容读取入口商品 ID（IIFE 未就绪时的竞态兜底）
      if (!qs.dataset.mskuEntryProductId) {
        var _existingData = qs.querySelector('[data-msku-group-data]');
        if (_existingData) {
          try {
            var _existingGd = JSON.parse(_existingData.textContent);
            if (_existingGd && _existingGd.currentProductId) {
              qs.dataset.mskuEntryProductId = String(_existingGd.currentProductId);
            }
          } catch(_ex) {}
        }
      }
      var _entryId = qs.dataset.mskuEntryProductId || '';
      var scrollTop = qs.scrollTop;
      var focused = qs.contains(document.activeElement) ? document.activeElement : null;
      var focusedKey = focused && focused.dataset.attrKey;
      var focusedValue = focused && focused.dataset.attrVal;
      _finishLoading();
      // Controls and coupon markup are ready before connecting the new gallery.
      qs.replaceChildren(_cloned);
      _mskuExecuteModalModules(qs);
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      if (window._syncKlipQuickViewCoupons) window._syncKlipQuickViewCoupons(qs);
      if (focusedKey) {
        var nextFocus = Array.from(qs.querySelectorAll('input[data-attr-key]')).find(function(input) {
          return input.dataset.attrKey === focusedKey && input.dataset.attrVal === focusedValue;
        });
        if (nextFocus) nextFocus.focus({ preventScroll: true });
      }
      qs.scrollTop = scrollTop;
      window._mskuLastShownModalProduct = { id: product.id, url: product.url, entryId: _entryId };
    }

    var cached = window._mskuPageCache[product.url];
    // 已缓存 HTML：直接渲染，无网络等待
    if (typeof cached === 'string') { _apply(cached); return; }
    // 预取进行中（Promise）：等其完成即渲染
    if (cached && typeof cached.then === 'function') {
      _startLoading();
      cached.then(function(t) { if (t) _apply(t); else _finishLoading(); });
      return;
    }

    // 未缓存：发起请求并缓存 Promise，避免并发重复请求
    _startLoading();
    var p = fetch(_mskuQuickViewUrl(product.url))
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(text) { window._mskuPageCache[product.url] = text; return text; })
      .catch(function(e) { delete window._mskuPageCache[product.url]; console.error('[msku] modal reload failed:', e); return null; });
    window._mskuPageCache[product.url] = p;
    p.then(function(t) { if (t) _apply(t); else _finishLoading(); });
  }
  // 暴露给 IIFE，让二次打开弹框时可以调用此函数恢复上次选中的商品
  window._mskuLoadProductInModal = _mskuLoadProductInModal;
  window._mskuRenderInModal = _mskuRenderInModal;

  // 捕获阶段：统一处理 msku 属性切换
  // - [data-modal] 内（Quick View 弹框）：原地替换弹框内容，不跳页
  // - 非弹框（PDP 主页）：导航到目标商品 URL（若弹框当前打开则阻止）
  // 同一套逻辑适用于列表页和详情页，IIFE 不再绑定任何 change 处理器
  document.addEventListener('change', function(e) {

    var input = e.target;
    if (!input || input.type !== 'radio' || !input.dataset.attrKey) return;

    var modal = input.closest('[data-modal]');

    // PDP（非弹框）：若 msku Quick View 弹框当前打开则拦截，防止意外导航
    if (!modal && document.querySelector('tool-tip[data-tool-tip-open="true"] [data-msku-picker-container]')) {
      e.stopImmediatePropagation();
      return;
    }

    // 取对应上下文的 group data
    var dataScript = modal
      ? modal.querySelector('[data-msku-group-data]')
      : (input.closest('.page-content') || document).querySelector('[data-msku-group-data]');
    if (!dataScript) return;

    var gd;
    try { gd = JSON.parse(dataScript.textContent); } catch(_e) { return; }

    var products = gd.groupProducts;
    if (!products || products.length < 2) return;

    var key = input.dataset.attrKey;
    var val = input.dataset.attrVal;

    // 收集当前选中属性（modal 作用域或 PDP picker 作用域）
    var selScope = modal || input.closest('[data-msku-picker-container]');
    var sel = {};
    if (selScope) {
      var checked = selScope.querySelectorAll('input[type="radio"][data-attr-key]:checked');
      for (var ci = 0; ci < checked.length; ci++) {
        sel[checked[ci].dataset.attrKey] = checked[ci].dataset.attrVal;
      }
    }
    sel[key] = val;

    // 优先：多属性完全匹配
    var target = null;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p.attributes) continue;
      var ok = true;
      var ks = Object.keys(sel);
      for (var k = 0; k < ks.length; k++) {
        if (p.attributes[ks[k]] !== sel[ks[k]]) { ok = false; break; }
      }
      if (ok) { target = p; break; }
    }
    // 兜底：只按当前切换的属性匹配
    if (!target) {
      for (var j = 0; j < products.length; j++) {
        if (products[j].attributes && products[j].attributes[key] === val) { target = products[j]; break; }
      }
    }
    if (!target) return;

    e.stopImmediatePropagation();

    if (modal) {
      // 弹框：原地替换内容（与列表页 Quick View 完全相同的路径）
      var toolTipContainer = input.closest('[data-tool-tip-content]');
      _mskuLoadProductInModal(target, toolTipContainer);
    } else {
      // PDP：整页导航到目标商品
      window.location.href = target.url;
    }
  }, true);
}
// ── 文档级代理结束 ────────────────────────────────────────────────────────────

(function () {
  // 优先取 Quick View modal 内的数据元素，避免 PDP 上也有同 id 元素时 getElementById 取到错误的
  var _allDataEls = document.querySelectorAll('[data-msku-group-data]');
  var dataEl = null;
  for (var _di = 0; _di < _allDataEls.length; _di++) {
    if (_allDataEls[_di].closest('[data-modal]')) { dataEl = _allDataEls[_di]; break; }
  }
  if (!dataEl) dataEl = _allDataEls[0] || null;
  if (!dataEl) return;

  var groupData;
  try {
    groupData = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var currentProductId = groupData.currentProductId;
  var groupProducts = groupData.groupProducts;
  var swatchData = groupData.swatchData || {};
  if (!groupProducts || groupProducts.length < 2) return;

  // 检测是否运行在 Quick View modal 上下文中（Quick Shop 在插入时会设置 data-modal）
  var isInModal = !!dataEl.closest('[data-modal]');
  // 将查询作用域限定到同一个 .page-content，避免跨弹框/PDP 取到错误容器
  var _pageContent = dataEl.closest('.page-content') || document;

  function normalizeSwatchName(value) {
    return String(value || '').trim().toLowerCase();
  }

  var normalizedSwatchData = {};
  Object.keys(swatchData).forEach(function (key) {
    normalizedSwatchData[normalizeSwatchName(key)] = swatchData[key];
  });

  // Build ordered map: attrKey => unique value array (in order encountered)
  var optionMap = {};
  for (var i = 0; i < groupProducts.length; i++) {
    var attrs = groupProducts[i].attributes || {};
    var keys = Object.keys(attrs);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k];
      var val = attrs[key];
      if (!optionMap[key]) optionMap[key] = [];
      if (optionMap[key].indexOf(val) === -1) optionMap[key].push(val);
    }
  }

  var attrKeys = Object.keys(optionMap);
  // qty 类属性排到末尾，与 Liquid 端排序保持一致
  var _nonQtyKeys = attrKeys.filter(function(k) {
    var kl = k.toLowerCase();
    return kl.indexOf('quantity') === -1 && kl.indexOf('qty') === -1;
  });
  var _qtyKeys = attrKeys.filter(function(k) {
    var kl = k.toLowerCase();
    return kl.indexOf('quantity') !== -1 || kl.indexOf('qty') !== -1;
  });
  attrKeys = _nonQtyKeys.concat(_qtyKeys);

  // Resolve current product and selected attrs
  var currentProduct = null;
  for (var i = 0; i < groupProducts.length; i++) {
    if (String(groupProducts[i].id) === String(currentProductId)) {
      currentProduct = groupProducts[i];
      break;
    }
  }

  var selectedAttrs = currentProduct ? Object.assign({}, currentProduct.attributes) : {};

  // Find product matching ALL given attrs (exact match on all keys)
  function findProduct(attrs) {
    var keys = Object.keys(attrs);
    for (var i = 0; i < groupProducts.length; i++) {
      var p = groupProducts[i];
      if (!p.attributes) continue;
      var match = true;
      for (var k = 0; k < keys.length; k++) {
        if (p.attributes[keys[k]] !== attrs[keys[k]]) {
          match = false;
          break;
        }
      }
      if (match) return p;
    }
    return null;
  }

  // Find first product that has at least the specified attr key=val
  function findProductByAttr(key, val) {
    for (var i = 0; i < groupProducts.length; i++) {
      var p = groupProducts[i];
      if (p.attributes && p.attributes[key] === val) return p;
    }
    return null;
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getSwatchEntry(value) {
    return normalizedSwatchData[normalizeSwatchName(value)] || null;
  }

  function applySwatchStyle(label, swEntry) {
    if (!label || !swEntry) return;

    var image = swEntry.image || swEntry.simage || '';
    var color = swEntry.color || swEntry.scolor || '';

    if (image) {
      label.style.setProperty('--swatch-bg-image', 'url(' + image + ')');
      label.style.setProperty('--swatch-bg-color', 'transparent');
      label.style.backgroundImage = 'url(' + image + ')';
      label.style.backgroundSize = 'cover';
      label.style.backgroundColor = 'transparent';
    } else if (color) {
      label.style.setProperty('--swatch-bg-color', color);
      label.style.setProperty('--swatch-bg-image', 'none');
      label.style.backgroundColor = color;
      label.style.backgroundImage = 'none';
    }
  }

  function applyRenderedSwatches(container) {
    var labels = container.querySelectorAll('label[data-msku-swatch-key]');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var swEntry = getSwatchEntry(label.dataset.mskuSwatchKey);
      label.dataset.mskuSwatchFound = swEntry ? 'true' : 'false';
      applySwatchStyle(label, swEntry);
    }
  }

  function render() {
    var container = _pageContent.querySelector('[data-msku-picker-container]') || document.querySelector('[data-msku-picker-container]');
    if (!container) return;

    var html = '';

    for (var i = 0; i < attrKeys.length; i++) {
      var attrKey = attrKeys[i];
      var vals = optionMap[attrKey];
      var selectedVal = selectedAttrs[attrKey] || '';

      var isColor = attrKey.toLowerCase() === 'color' || attrKey.toLowerCase() === 'colour';
      html += '<fieldset class="variant-button-wrap' + (isColor ? ' is_color_active' : '') + '">';
      html += '<legend class="label variant__label">';
      html += '<span class="variant__label-left">';
      html += esc(attrKey) + ': ';
      html += '<span class="variant__label-info"><span data-variant-color-label>' + esc(selectedVal) + '</span></span>';
      html += '</span>';
      if (i === attrKeys.length - 1 && currentProduct && currentProduct.restockTime) {
        html += '<span class="in-stock-in-4-weeks" role="status" aria-live="polite">';
        html += '<span class="stock-main-label">' + esc(currentProduct.restockTime) + '</span></span>';
      }
      html += '</legend>';

      for (var j = 0; j < vals.length; j++) {
        var val = vals[j];
        var isSelected = val === selectedVal;
        var inputId = currentProductId + '-msku-' + i + '-' + j;

        var tryAttrs = Object.assign({}, selectedAttrs);
        tryAttrs[attrKey] = val;
        var target = findProduct(tryAttrs);
        var isUnavailable = !target || !target.available;

        // 使用主题原生的 input[radio] + label 结构，与 components.css 样式完全匹配
        html += '<input class="visually-hidden" type="radio"';
        html += ' id="' + inputId + '"';
        html += ' name="msku-' + esc(attrKey) + '"';
        html += ' value="' + esc(val) + '"';
        html += ' data-attr-key="' + esc(attrKey) + '"';
        html += ' data-attr-val="' + esc(val) + '"';
        if (target) {
          html += ' data-product-id="' + esc(target.id) + '"';
          html += ' data-variant-id="' + esc(target.variantId) + '"';
          html += ' data-product-url="' + esc(target.url) + '"';
          if (target.images && target.images[0]) html += ' data-product-image="' + esc(target.images[0]) + '"';
        }
        if (isSelected) html += ' checked';
        if (isUnavailable) html += ' data-disabled';
        html += '>';

        html += '<label class="variant__button-label" for="' + inputId + '"';
        if (isUnavailable) html += ' data-disabled=""';
        if (isColor) {
          html += ' data-color-swatch="' + esc(attrKey) + '"';
          var swatchKey = normalizeSwatchName(val);
          var swEntry = getSwatchEntry(val);
          html += ' data-msku-swatch-key="' + esc(swatchKey) + '"';
          html += ' data-msku-swatch-found="' + (swEntry ? 'true' : 'false') + '"';
          if (swEntry) {
            var swatchImage = swEntry.image || swEntry.simage || '';
            var swatchColor = swEntry.color || swEntry.scolor || '';
            if (swatchImage) {
              html += ' style="--swatch-bg-image:url(' + swatchImage + ');--swatch-bg-color:transparent;background-image:url(' + swatchImage + ');background-size:cover;background-color:transparent;"';
            } else if (swatchColor) {
              html += ' style="--swatch-bg-color:' + swatchColor + ';--swatch-bg-image:none;background-color:' + swatchColor + ';"';
            }
          }
        }
        html += '>';
        html += esc(val);
        if (isUnavailable) html += '<span class="visually-hidden">Unavailable</span>';
        html += '</label>';
      }

      html += '</fieldset>';
    }

    container.innerHTML = html;
    applyRenderedSwatches(container);
    // 事件处理由文档级代理负责，不绑定 onInputChange
  }

  function onInputChange() {
    // 安全守卫：modal 内的 radio 由文档级代理处理，不走此函数，防止意外触发导航
    if (this.closest && this.closest('[data-modal]')) return;
    // 额外守卫：modal 隔离后的 radio name 以 --modal 结尾
    if (this.name && this.name.endsWith('--modal')) return;
    var key = this.dataset.attrKey;
    var val = this.dataset.attrVal;

    var tryAttrs = Object.assign({}, selectedAttrs);
    tryAttrs[key] = val;
    var target = findProduct(tryAttrs);

    if (!target) {
      target = findProductByAttr(key, val);
      if (target) Object.assign(selectedAttrs, target.attributes);
    } else {
      selectedAttrs[key] = val;
    }

    if (target) navigateTo(target);
  }

  function loadProductInModal(product) {
    var quickShopContainer = _pageContent.closest('[data-tool-tip-content]') || document.querySelector('[data-tool-tip-content]');
    if (!quickShopContainer) return;
    window._mskuLoadProductInModal(product, quickShopContainer);
  }

  function navigateTo(product) {
    if (isInModal) {
      loadProductInModal(product);
      return;
    }
    // 安全守卫：msku Quick View 弹框打开时禁止 PDP 导航，防止任何异常路径意外触发页面跳转
    if (document.querySelector('tool-tip[data-tool-tip-open="true"] [data-msku-picker-container]')) return;
    // 非弹框场景：整页跳转（Analytics 自动触发，主题 JS 完整重跑）
    window.location.href = product.url;

    // ── 以下为 history.pushState 无刷新方案，切换时取消注释并删除上面一行 ──────────────
    // history.pushState({ mskuProductId: product.id }, '', product.url);
    //
    // var titleParts = document.title.split(' – ');
    // if (titleParts.length > 1) {
    //   titleParts[0] = product.title;
    //   document.title = titleParts.join(' – ');
    // } else {
    //   document.title = product.title;
    // }
    //
    // // All H1 product titles (appear in both left and right columns)
    // var titles = document.querySelectorAll('.product-single__title');
    // for (var i = 0; i < titles.length; i++) {
    //   titles[i].textContent = product.title;
    // }
    //
    // // Breadcrumb
    // var breadcrumb = document.querySelector('.breadcrumb__link_producttitle');
    // if (breadcrumb) {
    //   breadcrumb.href = product.url;
    //   breadcrumb.textContent = product.title;
    // }
    //
    // // Product image
    // if (product.images && product.images[0]) {
    //   var newSrc = product.images[0];
    //   var mainImg = document.querySelector('.product-main-slide img');
    //   if (mainImg) {
    //     mainImg.src = newSrc;
    //     mainImg.srcset = '';
    //     if (mainImg.dataset) mainImg.dataset.src = newSrc;
    //   }
    //   var modalImg = document.querySelector('#productImagesModal .swiper-slide img');
    //   if (modalImg) {
    //     modalImg.src = newSrc;
    //     modalImg.srcset = '';
    //   }
    // }
    //
    // // Prices (appear in both columns)
    // updatePrices(product);
    //
    // // Cart form variant ID
    // var variantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    // if (variantInput) variantInput.value = product.variantId;
    //
    // // Buy button availability
    // var submitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    // if (submitBtn) {
    //   submitBtn.disabled = !product.available;
    //   if (!product.available) submitBtn.setAttribute('aria-disabled', 'true');
    //   else submitBtn.removeAttribute('aria-disabled');
    // }
    //
    // // Wishlist button
    // var wishlistBtn = document.getElementById('wishlist-add-btn');
    // if (wishlistBtn) {
    //   wishlistBtn.dataset.productId = product.id;
    //   wishlistBtn.dataset.variantId = product.variantId;
    //   wishlistBtn.dataset.productHandle = product.handle;
    //   wishlistBtn.dataset.productTitle = product.title;
    //   wishlistBtn.dataset.productPrice = product.priceFormatted;
    //   var iconEmpty = wishlistBtn.querySelector('.wishlist-icon-empty');
    //   var iconFilled = wishlistBtn.querySelector('.wishlist-icon-filled');
    //   if (iconEmpty) iconEmpty.style.display = '';
    //   if (iconFilled) iconFilled.style.display = 'none';
    // }
    // ── pushState 方案结束 ────────────────────────────────────────────────────────
  }

  function updatePrices(product) {
    var isOnSale = product.compareAtPrice && product.compareAtPrice > product.price;

    var containers = document.querySelectorAll('.block-price__container');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];

      if (!product.available) {
        container.setAttribute('data-sold-out', '');
      } else {
        container.removeAttribute('data-sold-out');
      }

      if (isOnSale) {
        container.setAttribute('data-on-sale', '');
      } else {
        container.removeAttribute('data-on-sale');
      }

      // Regular price span (second span inside .block-price__regular)
      var regularDiv = container.querySelector('.block-price__regular');
      if (regularDiv) {
        var spans = regularDiv.querySelectorAll('span:not(.visually-hidden)');
        if (spans.length > 0) {
          spans[spans.length - 1].textContent = product.priceFormatted;
        }
      }

      // Sale section: current price
      var salePriceEl = container.querySelector('.no_old_product_price');
      if (salePriceEl) {
        salePriceEl.textContent = product.priceFormatted;
      }

      // Compare-at price
      var compareEl = container.querySelector('.has_old_product_price');
      if (compareEl) {
        compareEl.textContent = isOnSale ? (product.compareAtPriceFormatted || '') : '';
      }
    }
  }

  // Browser back/forward support
  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.mskuProductId) return;
    var product = null;
    for (var i = 0; i < groupProducts.length; i++) {
      if (String(groupProducts[i].id) === String(e.state.mskuProductId)) {
        product = groupProducts[i];
        break;
      }
    }
    if (product) {
      Object.assign(selectedAttrs, product.attributes);
      navigateTo(product);
      render();
    }
  });

  if (!isInModal) {
    render();
  } else {
    // isInModal = true：渲染 picker 并隔离 radio（_apply 也会调用，此处处理初次打开）
    if (window._mskuRenderInModal) window._mskuRenderInModal(_pageContent);

    // 标记本次弹窗的入口商品，供 _apply 写入 entryId 和跨商品防污染判断使用
    var _restoreQs = _pageContent.closest('[data-tool-tip-content]') || document.querySelector('[data-tool-tip-content]');
    if (_restoreQs) {
      if (!_restoreQs.dataset.mskuEntryProductId) {
        _restoreQs.dataset.mskuEntryProductId = String(currentProductId);
      }
    }

    // 二次打开时恢复上次切换到的商品（仅限相同入口商品，防止 B 的 Quick View 被 A 的历史记录污染）
    var _lastShown = window._mskuLastShownModalProduct;
    if (_lastShown && _lastShown.entryId && _lastShown.entryId === String(currentProductId) && String(_lastShown.id) !== String(currentProductId) && window._mskuLoadProductInModal) {
      var _lastProduct = null;
      for (var _lpi = 0; _lpi < groupProducts.length; _lpi++) {
        if (String(groupProducts[_lpi].id) === String(_lastShown.id)) { _lastProduct = groupProducts[_lpi]; break; }
      }
      if (_lastProduct) {
        window._mskuLoadProductInModal(_lastProduct, _restoreQs);
      }
    }

    // 同组商品仅在 hover/focus/touch 意图出现时预取，避免弹框打开后立即抢占带宽。
  }
})();
